export default __webpack_public_path__ + "static/media/banner_2.bab9e4da.jpg";